const autoGrow = (element: any) => {
  element.target.style.height = "42px";
  element.target.style.height = `${element.target.scrollHeight}px`;
};

export default autoGrow;
